import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';
import BasketLineItemImage from '@/ui/views/checkout/BasketLineItemImage.vue';
import { store } from '@/store';
import UpdateLineItemWebRequest = Vertica.LouisPoulsen.Application.Commerce.Requests.UpdateLineItemWebRequest;
import UpdateLineReferenceWebRequest = Vertica.LouisPoulsen.Application.Commerce.Requests.UpdateLineReferenceWebRequest;
import RemoveFromBasketWebRequest = Vertica.LouisPoulsen.Application.Commerce.Requests.RemoveFromBasketWebRequest;
import { BasketType } from '@/enums';
import { useImpersonation } from '@/store/impersonation.composable';
import NumberService from '@/services/number.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'QuoteBasketLineItemB2B',
  props: {
    lineItem: null,
    salesInfo: null
  },
  setup(__props: any) {

const props = __props as {lineItem: LineItemViewObject, salesInfo?: SalesInfoViewObject }


const isBasketLocked = computed<boolean>(() => store.getters['basket/isBasketLocked']);

function updateLineItem(request: UpdateLineItemWebRequest) {
    store.dispatch('quotebasket/updateLineItem', request);
}
function updateLineReference(request: UpdateLineReferenceWebRequest) {
    store.dispatch('quotebasket/updateLineReference', request);
}
function removeFromBasket(request: RemoveFromBasketWebRequest) {
    store.dispatch('quotebasket/removeFromBasket', request);
}

const stock = ref<string>('-');
const delivery = ref<string>('-');
const retailPrice = ref<string>('-');
const originalDiscount = ref<string>('-');
const salesPriceExclVat = ref<string>('-');

const reference = ref<string>('');
const quantity = ref<string>('');

const discount = ref<string>(props.lineItem.discountPercent || props.lineItem.originalDiscountPercent);
const editDiscount = ref<boolean>(false);

const { canAssignManualDiscount } = useImpersonation();

function toggleEditDiscount() {
    if (!editDiscount.value) {
        editDiscount.value = true;
        if (props.lineItem.discountPercent !== null) {
            discount.value = props.lineItem.discountPercentage !== null ? props.lineItem.discountPercentage.toString() : '';
        } else {
            discount.value = props.lineItem.originalDiscountPercentage !== null ? props.lineItem.originalDiscountPercentage.toString() : '';
        }
    } else {
        onDiscountChange();
    }
}

watch(() => props.salesInfo, onSalesInfoChanged);

function onSalesInfoChanged() {
    if (!props.salesInfo) { return; }

    stock.value = props.salesInfo.stock;
    delivery.value = props.salesInfo.delivery;
    retailPrice.value = props.salesInfo.priceRetail;
    originalDiscount.value = props.salesInfo.discount;
    salesPriceExclVat.value = props.salesInfo.salesPriceExclVat;
}

function updateReference(input: string) {
    reference.value = input;
}

function updateQuantity(input: string) {
    quantity.value = input;
}

function onReferenceChange() {
    const request : UpdateLineReferenceWebRequest = {
        lineItemId: props.lineItem.lineItemId,
        lineReference: reference.value,
        basketType: BasketType.Quotation as any
    };
    updateLineReference(request);
}

function onQuantityChange() {
    if (!quantity.value) { return; };

    const quantityValue = parseInt(quantity.value, 10);

    if (props.lineItem.quantity === quantityValue) { return; }

    updateLineItem({
        id: props.lineItem.lineItemId,
        quantity: quantityValue,
        basketType: BasketType.Quotation as any,
        discountPercent: props.lineItem.discountPercentage
    });
}

function onDiscountChange() {
    if (!discount.value) { return; };

    const discountValue = NumberService.parseIntWithDefault(discount.value);

    if (props.lineItem.discountPercentage === discountValue) { return; }

    updateLineItem({
        id: props.lineItem.lineItemId,
        quantity: props.lineItem.quantity,
        basketType: BasketType.Quotation as any,
        discountPercent: discountValue
    });
    editDiscount.value = false;
}

function onRemoveFromBasket() {
    removeFromBasket({ id: props.lineItem.lineItemId, basketType: BasketType.Quotation as any });
}

return { __sfc: true,props, isBasketLocked, updateLineItem, updateLineReference, removeFromBasket, stock, delivery, retailPrice, originalDiscount, salesPriceExclVat, reference, quantity, discount, editDiscount, canAssignManualDiscount, toggleEditDiscount, onSalesInfoChanged, updateReference, updateQuantity, onReferenceChange, onQuantityChange, onDiscountChange, onRemoveFromBasket, BasketLineItemImage }
}

})